import { Component } from "react";

const subtitle = "Get the best Trackmania content on Twitch!";
const title = "Check out our streams!";

const VideoListContentTop = [
  {
    imgUrl: "/assets/images/video/video-stream1.jpg",
    imgAlt: "BirdieTM Stream",
    videoLink: "https://www.twitch.tv/birdietm",
    title: "BirdieTM on Twitch",
    desc: "Watch the best Trackmania content live on Twitch",
  },
];

class VideoSection extends Component {
  render() {
    return (
      <section className="video-section padding-top padding-bottom">
        <div className="container">

          <div className="section-header-right">
            <p className="text-anim-fade-down js-animate delay-sm">
              {subtitle}
            </p>
            <h2 className="text-anim-typing js-animate delay-md">
              {title}
            </h2>
          </div>

          <div className="row g-4 justify-content-center">
            {VideoListContentTop.map((val, i) => (
              <div className="col-lg-6 col-12" key={i}>
                <div className="video-item">
                  <div className="video-inner">

                    <a
                      href={val.videoLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="video-link"
                    >
                      <div className="video-thumb">
                        <img src={val.imgUrl} alt={val.imgAlt} />
                      </div>

                      <div className="video-icon">
                        <i className="icofont-play"></i>
                      </div>
                    </a>

                    <div className="video-content">
                      <h3>{val.title}</h3>
                      <p>{val.desc}</p>
                    </div>

                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>
    );
  }
}

export default VideoSection;
